module.exports = __webpack_public_path__ + "static/media/animated-flame.30607673.webp";